import { Container } from "./styles";
import profileImage from "../../assets/about-img.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id='about'>
      <div className='about-text '>
        <ScrollAnimation animateIn='fadeInLeft'>
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeInLeft' delay={0.2 * 1000}>
          <p>
            My name is <span style={{ color: "#5e60ce" }}>Shadab Alam</span>, a Full Stack Developer with 3+ years of experience building
            end-to-end web applications. I work across the stack &mdash; front-end with React &amp; Next.js and back-end with Node.js,
            Express and FastAPI.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeInLeft' delay={0.4 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>
            I design REST APIs, model relational and NoSQL databases (PostgreSQL, MySQL, MongoDB), and ship clean, scalable,
            production-ready solutions. I also enjoy working with AI-powered features, cloud platforms (AWS, Azure) and
            monitoring/observability tooling.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeInLeft' delay={0.6 * 1000}>
          <p>
            I am hardworking and results-oriented, collaborate effectively in agile teams, and always seek to achieve my best version.
          </p>
        </ScrollAnimation>
      </div>
      <div className='about-image'>
        <ScrollAnimation animateIn='fadeInRight' delay={0.6 * 1000}>
          <img src={profileImage} alt='Shadab Alam' />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
